<template lang="pug">
section
  s-page-title(
    :previous='true'
    :title='id ? "Редактирование менеджера" : "Добавление менеджера"'
  )
  v-card
    v-container(fluid grid-list-xl)
      v-layout(wrap)
        v-flex(xs12 sm3)
          form(ref='form' class='user-ava' :class=`{ xs: $vuetify.breakpoint.name === "xs" }`)
            //- Кнопка добавления фото
            span(class='add-photo-btn' :style='{ top: y, right: x }')
              v-btn(color='primary' small fab dark @click.stop)
                v-icon(dark medium) add
              input(@change='readFromFile' type='file' class='upload')

            //- Фото пользователя
            v-avatar(color='grey lighten-4')
              img(v-if='preview' :src='preview')
              img(v-else-if='item.avatar_url' :src='item.avatar_url')

              input(@change='readFromFile' type='file' class='upload')
              span(v-if='!isLoading && !item.avatar_url' class='hint') Добавить фото

          //- Удаляет превью на клиенте
          v-layout(v-if='preview' class='mt-4')
            v-btn(flat @click='deletePreview' style='margin: auto') Удалить

          //- Удаляет ранее загруженное фото
          v-layout(v-else-if='item.avatar_url' class='mt-4')
            v-btn(flat @click='deletePhoto' :disabled='deleting' style='margin: auto') Удалить

          v-flex(xs12)
            s-image-upload(
              :src='item.avatar_corp_url'
              v-model='item.avatar_corp'
              label='КОРП (поясное фото)'
            ) 
          v-flex(xs12)
            s-image-upload(
              :src='item.qr_code_url'
              v-model='item.qr_code'
              label='QR Code'
            ) 
        v-flex(xs12 sm8 offset-sm1)
          v-layout(wrap)
            v-flex(xs6)
              v-text-field(
                :error='errors.has("second_name")'
                :error-messages='errors.first("second_name")'
                v-model='item.second_name'
                label='Фамилия'
              )
            v-flex(xs6)
              v-text-field(
                :error='errors.has("first_name")'
                :error-messages='errors.first("first_name")'
                v-model='item.first_name'
                label='Имя'
              )
            v-flex(xs6)
              v-text-field(
                v-model='item.patronymic_name'
                label='Отчество'
              )
            v-flex(xs6)
              s-date-picker(
                :validator='errors'
                v-model='item.birthday'
                name='birthday'
              )
            v-flex(xs12)
              v-text-field(
                :error='errors.has("position")'
                :error-messages='errors.first("position")'
                v-model='item.position'
                label='Должность'
              )
            v-flex(xs12 md6)
              s-phone-input(
                :error='errors.has("phone")'
                :error-messages='errors.first("phone")'
                v-model='item.phone'
                label='Телефон'
              )
            v-flex(xs12 md6)
              v-text-field(
                :error='errors.has("phone_inside")'
                :error-messages='errors.first("phone_inside")'
                v-model='item.phone_inside'
                label='Вн.телефон'
              )
            v-flex(xs12 md6)
              v-text-field(
                :error='errors.has("email")'
                :error-messages='errors.first("email")'
                v-model='item.email'
                label='Email'
              )
            v-flex(xs12 md6)
              v-checkbox(
                v-model='item.published'
                label='Публиковать на сайте'
                color='primary'
              )
            v-flex(xs12)
              v-select(
                  v-model='item.tags'
                  label='Тэги для менеджера'
                  multiple
                  chips
                  :items = 'tagsList'
                  item-value='id'
                  item-text='name'
                  class='tag-input'
                  retur-object
                  type = 'array'
              )
            v-flex(xs12)
              v-textarea(
                :error='errors.has("description")'
                :error-messages='errors.first("description")'
                v-model='item.description'
                label='Комментарий'
              )

    v-card-actions(class='large')
      v-spacer
      s-back-btn
      v-btn(
        :loading='isLoading'
        @click.native='onSave'
        color='primary'
        depressed
      ) Сохранить
  //- Диалог кадрирования роли
  v-dialog(scrollable v-model='dialog' max-width='340px' persistent lazy)
    v-card(class='combo-card')
      v-toolbar(v-if='cropInitialized' flat color='white' prominent)
        v-toolbar-title Кадрирование изображения
      v-card-text
        div(ref='upload')
        v-layout(v-if='!cropInitialized' align-center d-flex class='mt-5 mb-5')
          v-progress-circular(:size='50' color='accent' indeterminate)
      v-card-actions(v-if='cropInitialized')
        v-spacer
        v-btn(@click.native='closeCropDialog' color='default' flat) Отмена
        v-btn(@click='getCropResult' color='primary' flat) Сохранить
  //- Менеджер в отделах
  departments(v-if='id' :managerId='id' class='mt-5')
</template>

<script>
import Croppie from 'croppie'
import 'croppie/croppie.css'

import { mapActions, mapGetters } from 'vuex'
import Departments from './Departments'

export default {
  props: ['id'],

  data: () => ({
    item: {},
    photo: null,
    preview: null,
    dialog: false,
    cropInitialized: false,
    deleting: false,
    x: null,
    y: null,
    tagsList: [
        {
          id: 'ipoteka',
          name: 'Ипотека'
        },
        {
          id: 'pressa',
          name: 'Пресса'
        },
        {
          id: 'demo',
          name: 'Демонстратор'
        },
        {
          id: 'sale',
          name: 'Продажи'
        },
        {
          id: 'leasing',
          name: 'Лизинг'
        }
      ]
  }),

  components: {
    Departments
  },

  async created() {
    if (this.id) {
      try {
        this.item = (await this.fetchSingle({ id: this.id })).data
      } catch (e) {
        this.$root.showSnack('Ошибка загрузки менеджера')
      }
    }

    window.addEventListener('resize', this.calcPhotoBtnPosition)
    this.calcPhotoBtnPosition()
  },

  destroyed() {
    this.destroyCrop()
    window.removeEventListener('resize', this.calcPhotoBtnPosition)
  },

  methods: {
    destroyCrop() {
      if (this.croppie) {
        this.croppie.destroy()
        this.croppie = null
      }
    },

    createCrop() {
      // eslint-disable-next-line
      this.croppie = new Croppie(this.$refs.upload, {
        viewport: {
          width: 200,
          height: 200,
          type: 'circle'
        },
        boundary: {
          width: 300,
          height: 300
        }
      })
    },

    closeCropDialog() {
      this.dialog = false
      this.cropInitialized = false
    },

    calcPhotoBtnPosition() {
      let { form } = this.$refs

      if (!form) return

      let r = form.clientWidth / 2

      this.x = r * Math.cos(225 * 0.0174533) + r + 'px'
      this.y = r * Math.sin(225 * 0.0174533) + r + 'px'
    },

    async getCropResult() {
      let format = {
        format: 'jpeg',
        circle: false,
        size: {
          width: 400,
          height: 400
        }
      }

      this.dialog = false

      this.photo = await this.croppie.result({ ...format, type: 'blob' })
      this.preview = await this.croppie.result({ ...format, type: 'base64' })

      this.cropInitialized = false
      this.destroyCrop()
    },

    readFromFile(event) {
      let file = event.target.files[0]
      let imageType = /image.*/

      if (file.type.match(imageType)) {
        let reader = new FileReader()

        if (this.$refs.form) {
          this.$refs.form.reset()
        }

        this.destroyCrop()

        reader.onload = () => {
          this.dialog = true

          setTimeout(() => {
            this.createCrop()

            this.croppie.bind({
              url: reader.result,
              zoom: false
            })

            this.cropInitialized = true
          }, 500)
        }

        reader.readAsDataURL(file)
      } else {
        this.$root.showSnack('Неподдерживаемый формат файла')
      }
    },

    unsetFile() {
      this.photo = null
    },

    createFormData() {
      let data = new FormData()

      if (null !== this.photo) {
        data.append('avatar', this.photo)
      }

      Object.keys(this.item).forEach(key => {
        if(key=='tags')
          data.append(key, this.item[key].join(','))
        else
          data.append(key, this.item[key])
      })

      return data
    },

    deletePreview() {
      this.preview = null
      this.unsetFile()
    },

    async deletePhoto() {
      if (await this.$confirm('Удалить фото?')) {
        this.item.avatar = null
        let data = this.createFormData()

        try {
          this.item = (
            await this.update({
              id: this.id,
              data
            })
          ).data
        } catch (e) {
          this.$root.showSnack('Ошибка удаления фото')
        }
      }
    },

    async onSave() {
      let data = this.createFormData()

      try {
        if (this.id) {
          await this.update({
            id: this.id,
            data
          })
        } else {
          await this.create({ data })
        }

        this.$root.showSnack(`Менеджер сохранен`)

        this.$router.push({
          name: 'Admin.Managers'
        })
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    ...mapActions('admin/managers', ['fetchSingle', 'update', 'create'])
  },

  computed: {
    ...mapGetters('admin/managers', ['isLoading'])
  }
}
</script>

<style scoped>
.user-ava {
  text-align: center;
  position: relative;
  cursor: pointer;
}
.user-ava.xs {
  max-width: 60%;
  margin: 0 auto;
  margin-top: 2em;
}
.user-ava >>> .v-avatar {
  width: 100% !important;
  height: auto !important;
  padding-bottom: 100%;
  position: relative;
  overflow: hidden;
}
.user-ava >>> .v-avatar img {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  object-fit: cover;
  z-index: 1;
  pointer-events: none;
}
.upload {
  top: 0;
  left: 0;
  bottom: 0;
  position: absolute;
  font-size: 500px;
  opacity: 0;
}
.add-photo-btn {
  opacity: 0;
  position: absolute;
  z-index: 2;
  overflow: hidden;
  margin-top: -20px;
  margin-right: -20px;
}
.add-photo-btn[style] {
  opacity: 1;
}
.add-photo-btn >>> [class*='v-btn'] {
  box-shadow: none;
  margin: 0;
}
.hint {
  top: 0;
  left: 0;
  text-align: center;
  right: 0;
  bottom: 0;
  position: absolute;
  display: flex;
  align-items: center;
  padding: 0 40px;
  font-size: 13px;
  font-weight: 500;
  opacity: 0.45;
  line-height: 1.25;
  flex-direction: column;
  justify-content: center;
  pointer-events: none;
}
</style>
